import { css as cssTest } from '@emotion/css'
import { default as emotionStyled } from '@emotion/styled'
import { MediaQueries } from '@hhgtech/hhg-components'
import { StyledExpandableContainer } from 'components/molecules/expandedCard/index.styled'
import { OvulationInfo } from 'components/templates/ovulationCalculator/ovulationInfo'
import styled, { css } from 'styled-components'

// import styled, { css } from 'styled-components'

export const parsedContentStyle = cssTest`
  p,
  li {
    margin-top: 8px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #404040; // gray700
  }

  h3 {
    margin-top: 16px;
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
  }

  ul {
    margin-top: 8px;
    padding-left: 16px;
    list-style-type: disc;

    li {
      margin-top: 8px;
    }
  }

  a {
    color: #1a80e3;

    &:not(:hover) {
      text-decoration: none;
    }
  }
`

export const StyledBabyPoopContainer = emotionStyled.div`
  margin: auto;
  padding-left: 16px;
  padding-right: 16px;
  max-width: calc(744px + 16px * 2);
  &[data-is-vietnam='true'] {
  }
`

export const StyledBabyPoopListItem = emotionStyled.div<{
  backgroundColor?: string
  borderColor?: string
}>`
  pointer-events: none;
  * {
    pointer-events: none;
  }
  border-radius: ${(props) => props.theme?.radius?.lg}px;
  padding: 16px;
  cursor: pointer;
  transition: background-color 300ms;
  background-color: ${(props) => props.backgroundColor};
  border: 1px solid ${(props) => props.borderColor};
  display: flex;
  flex-direction: column;

  &:hover {
    background-color: ${(props) => props.theme?.colors?.neutral?.[2]};
  }

  img {
    width: 100%;
    max-height: 80px;
    object-fit: cover;
    border-radius: 4px;
    filter: blur(3px);
  }

  .item-see-more {
    font-size: 12px;
    margin-top: auto;
    color: ${(props) => props.theme?.fn?.primaryColor()}
  }
`

export const StyledBabyPoopSignatureColorBar = emotionStyled.div<{
  signatureColor: string
  width: number | string
}>`
  width: ${(props) => props.width}px;
  height: 8px;
  background-color: ${(props) => props.signatureColor};
  border-radius: 4px;
  flex-shrink: 0;
`

export const StyledBabyPoopHeader = emotionStyled.div<{
  backgroundImage: string
}>`
    background-image: url(${(props) => props.backgroundImage});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-color: ${(props) =>
      props.backgroundImage
        ? 'transparent'
        : props.theme.colors[props.theme.primaryColor as string][0]};
    min-height: 330px;
    padding: 16px 0;

    .find-out-button {
      & * {
        pointer-events: none;
      }

      ${MediaQueries.mbDown} {
        width: 100%;
      }
    }
    &[data-is-vietnam='true'] {
      background-position: top center;
      background-size: cover;
    }
    ${MediaQueries.mbDown} {
      &[data-is-vietnam='true'] {
        min-height: 400px;
        background-size: cover;
        background-position: unset;
      }
    }
  `

export const StyledBabyPoopHeaderContent = emotionStyled.div`
  display: flex;
  gap: 32px;
  padding: 24px 0;
  justify-content: space-between;
  .description {
    margin-top: 16px;
    white-space: pre-wrap;
  }
  .reviewer {
    margin-top: 16px;
    margin-bottom: 32px;
  }
  ${MediaQueries.mbDown} {
    flex-direction: column;
    align-
    
  }
  &[data-is-vietnam='true'] {
    padding: 0;
    .description {
      margin-top: 6px;
    }
    .reviewer {
      margin-bottom: 0;
    }

    ${MediaQueries.mbDown} {
      flex-direction: column;
    }
  }
`

export const StyledBabyPoopHeaderContentText = emotionStyled.div<{
  isSponsored: boolean
}>`
  max-width: 647px;

  ${MediaQueries.mbDown} {
    order: 2;
  }
`

export const StyledBabyPoopHeaderContentImage = emotionStyled.img`
  max-width: 320px;

  ${MediaQueries.mbDown} {
    max-width: 240px;
    order: 1;
  }

  ${MediaQueries.tdDown} {
    align-self: center;
  }
`

export const StyledBabyPoopHeaderReview = emotionStyled.div`
  display: flex;
  gap: 4px;

  svg {
    margin-top: 3px;
    flex-shrink: 0;
  }

  a {
    &:not(:hover) {
      text-decoration: none;
    }
  }
`

export const StyledBabyPoopIntroduceParsedContent = emotionStyled.div`
  h2, h3 {
    font-weight: 700;
    font-size: 18px;
    line-height: 32px;
    margin-bottom: 8px;
    color: ${(props) => props.theme.colors.darkGray}
  }

  p {
    margin-bottom: 24px;
  }

  ${parsedContentStyle}
`

export const StyledBabyPoopInfo = styled(OvulationInfo)<{
  withDisclaimer: boolean
}>`
  &.faqs-block {
    ${(props) =>
      props.withDisclaimer
        ? css`
            border-top: 8px solid ${(props) => props.theme?.colors.neutral50};
          `
        : css`
            margin-top: 24px;
          `}
  }

  p {
    transition: all 300ms;
  }

  ${StyledExpandableContainer} {
    ${parsedContentStyle}
  }
`

export const StyledBabyPoopInnerContent = emotionStyled.div`
  ${parsedContentStyle}
`
